import { Component, Input, OnInit, Output, EventEmitter, ElementRef } from "@angular/core";
import { NzModalService, NzMessageService } from "ng-zorro-antd";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
// import { BcacHttpService } from 'bcac-lib/services/bcac-http.service';
import { TableService } from '../table.service';
import * as _ from 'lodash'
import { SimpleChanges } from '@angular/core';
import { stringify } from "querystring";

@Component({
  selector: "bcac-common-table",
  templateUrl: "./bcac-common-table.component.html",
  styleUrls: ["./bcac-common-table.component.scss"],
})
export class BcacCommonTableComponent implements OnInit {
  constructor(
    private nzMessageService: NzMessageService,
    private elementRef: ElementRef,
    // private bcacHttpService: BcacHttpService
    private tableService: TableService
  ) { }

  redColor = "#FF0000";
  greenColor = "#7ED320";
  yellowColor = "#f2dd21";
  grayColor = "#bab7b5";

  @Output()
  checkBoxEmit = new EventEmitter<{ [key: string]: boolean }>();

  @Output()
  tdClickEmit = new EventEmitter<any>();
  tdClick(field: string, data: any) {
    this.tdClickEmit.emit({
      field: field,
      data: data
    });
    console.log("tdClick", {
      field: field,
      data: data
    });
  }

  tableSearchValue: string = "";

  tableloading: boolean = false;

  @Input()
  set bcacLoading(value: boolean) {
    this.tableloading = value;
  }

  @Output()
  bcacAddEmit = new EventEmitter<any>();
  clickAdd() {
    this.bcacAddEmit.emit(1);
  }

  @Output()
  bcacBatchDeleteEmit = new EventEmitter<any[]>();
  clickBatchDelete() {
    let checkedIdList = [];
    for (let key in this.mapOfCheckedId) {
      if (this.mapOfCheckedId[key]) {
        checkedIdList.push(key);
      }
    }
    if (checkedIdList.length > 0) {
      this.bcacBatchDeleteEmit.emit(checkedIdList);
    } else {
      this.nzMessageService.info("无选中记录");
    }
  }

  @Output()
  BcacBatchDownloadEmit = new EventEmitter<any[]>();
  batchDownload() {
    let checkedIdList = [];
    for (let key in this.mapOfCheckedId) {
      if (this.mapOfCheckedId[key]) {

        checkedIdList.push(key);
      }
    }
    let checkedObjList = this.tableData.filter(element => checkedIdList.indexOf(element[this.tableContent.uniqueIndex] + "") > -1);
    // in语法有问题，舍弃in
    // let checkedObjList = this.tableData.filter(element=> (element[this.tableContent.uniqueIndex] + "") in checkedIdList);
    if (checkedObjList.length > 0) {
      this.BcacBatchDownloadEmit.emit(checkedObjList);
    } else {
      this.nzMessageService.info("无选中记录");
    }
  }

  // row operation
  @Output()
  bcacDetailEmit = new EventEmitter<any>();
  clickDetail(data) {
    this.bcacDetailEmit.emit(data);
  }

  @Output()
  bcacEditorEmit = new EventEmitter<any>();
  clickEditor(data) {
    this.bcacEditorEmit.emit(data);
  }

  @Output()
  bcacDeleteEmit = new EventEmitter<any>();
  clickDelete(data) {
    this.bcacDeleteEmit.emit(data);
  }

  @Output()
  bcacReviewEmit = new EventEmitter<any>();
  clickReview(data) {
    this.bcacReviewEmit.emit(data);
  }

  trClickConf: {
    open: boolean,
    activeColor: string,
  } = {
      open: false,
      activeColor: "#99CCCC",
    }
  activeTrId = null;

  @Output()
  trClickEmit = new EventEmitter<any>();
  trClick(data) {
    if (!this.trClickConf.open) {
      return;
    }
    if (this.activeTrId === null) {
      this.activeTrId = data[this.tableContent.uniqueIndex];
      this.trClickEmit.emit(data);
    } else {
      if (this.activeTrId === data[this.tableContent.uniqueIndex]) {
        this.activeTrId = null;
        this.trClickEmit.emit(null);
      } else {
        this.activeTrId = data[this.tableContent.uniqueIndex];
        this.trClickEmit.emit(data);
      }
    }
  }

  @Input()
  set bcacOpenTrClick(value: boolean) {
    this.trClickConf.open = true
  }

  @Input()
  set bcacTrClickColor(value: string) {
    this.trClickConf.activeColor = value;
  }

  @Input()
  tableData: any[] = [];

  tableTitle = {
    show: true,
    label: "基础数据表",
  };

  @Input()
  set bcacShowTitle(value) {
    this.tableTitle.show = true,
      this.tableTitle.label = value;
  }

  @Input()
  set bcacCloseTitle(value) {
    this.tableTitle.show = false;
  }

  // 右侧固定操作列
  rightFixedOperationColumn = "";

  @Input()
  set bcacRightFixedOperationColumn(value: string) {
    this.rightFixedOperationColumn = value;
  }

  colorRange: any = {};

  // @Input()
  tableIconRow = {
    show: true,
    iconDivider: true,
    // refreshIcon: {
    //   show: false,
    //   label: "刷新",
    // },
    addIcon: {
      show: true,
      label: "新增",
    },
    configIcon: {
      show: true,
      label: "设置",
    },
    deleteIcon: {
      show: true,
      label: "删除",
    },
    excelIcon: {
      show: true,
      label: "导出",
    },
    excelIcon1: {
      show: false,
      label: "导出",
    },
    batchDownload: {
      show: true,
      label: "下载",
    },
    searchInput: {
      show: true
    },
    batchReview: {
      show: false,
      label: "批量审核"
    },
    batchDistributeOrder: {
      show: false,
      label: "批量派单"
    },
    batchTurnDown: {
      show: false,
      label: "批量驳回"
    },
    batchSubmit: {
      show: false,
      label: "批量提交"
    },
    batchImport: {
      show: false,
      label: "批量导入"
    },
    downTemplate: {
      show: false,
      label: "下载模板"
    },
    newUser: {
      show: false,
      label: "新建用户"
    },
    newRole: {
      show: false,
      label: "新建角色"
    },
  };

  @Input()
  set bcacShowBatchDistributeOrderIcon(value: boolean) {
    this.tableIconRow.batchDistributeOrder.show = true;
  }

  @Output()
  bcacBatchDistributeOrderEmit = new EventEmitter<any>();
  clickBatchDistributeOrder() {
    let checkedObjList = this.getCheckedObj();
    if (checkedObjList.length > 0) {
      this.bcacBatchDistributeOrderEmit.emit(checkedObjList);
    } else {
      this.nzMessageService.info("无选中记录");
    }
  }

  @Input()
  set bcacCloseIconDivider(value: boolean) {
    this.tableIconRow.iconDivider = false;
  }

  @Input()
  set bcacShowNewRoleIcon(value: boolean) {
    this.tableIconRow.newRole.show = true;
  }

  @Output()
  bcacNewRoleEmit = new EventEmitter<any>();
  clickNewRole() {
    this.bcacNewRoleEmit.emit(1);
  }


  @Input()
  set bcacShowNewUserIcon(value: boolean) {
    this.tableIconRow.newUser.show = true;
  }

  @Output()
  bcacNewUserEmit = new EventEmitter<any>();
  clickNewUser() {
    this.bcacNewUserEmit.emit(1);
  }

  @Input()
  set bcacShowDownTemplateIcon(value: boolean) {
    this.tableIconRow.downTemplate.show = true;
  }

  @Output()
  bcacDownTemplateEmit = new EventEmitter<any>();
  clickDownTemplate() {
    this.bcacDownTemplateEmit.emit(1);
  }

  @Input()
  set bcacShowBatchImportIcon(value: boolean) {
    this.tableIconRow.batchImport.show = true;
  }

  @Output()
  bcacBatchImportEmit = new EventEmitter<any>();
  clickBatchImport() {
    this.bcacBatchImportEmit.emit(1);
  }

  @Input()
  set bcacShowBatchSubmitIcon(value: boolean) {
    this.tableIconRow.batchSubmit.show = true;
  }

  @Output()
  bcacBatchSubmitEmit = new EventEmitter<any>();
  clickBatchSubmit() {
    let checkedObjList = this.getCheckedObj();
    if (checkedObjList.length > 0) {
      this.bcacBatchSubmitEmit.emit(checkedObjList);
    } else {
      this.nzMessageService.info("无选中记录");
    }
  }


  @Input()
  set bcacShowBatchTurnDownIcon(value: boolean) {
    this.tableIconRow.batchTurnDown.show = true;
  }

  @Output()
  bcacBatchTurnDownEmit = new EventEmitter<any>();
  clickBatchTurnDown() {
    let checkedIdList = [];
    for (let key in this.mapOfCheckedId) {
      if (this.mapOfCheckedId[key]) {

        checkedIdList.push(key);
      }
    }
    let checkedObjList = this.tableData.filter(element => checkedIdList.indexOf(element[this.tableContent.uniqueIndex] + "") > -1);
    // in语法有问题，舍弃in
    // let checkedObjList = this.tableData.filter(element=> (element[this.tableContent.uniqueIndex] + "") in checkedIdList);
    if (checkedObjList.length > 0) {
      this.bcacBatchTurnDownEmit.emit(checkedObjList);
    } else {
      this.nzMessageService.info("无选中记录");
    }
  }

  getCheckedObj() {
    let checkedIdList = [];
    for (let key in this.mapOfCheckedId) {
      if (this.mapOfCheckedId[key]) {

        checkedIdList.push(key);
      }
    }
    let checkedObjList = this.tableData.filter(element => checkedIdList.indexOf(element[this.tableContent.uniqueIndex] + "") > -1);
    return checkedObjList;
  }

  @Input()
  set bcacShowBatchReviewIcon(value: boolean) {
    this.tableIconRow.batchReview.show = true;
  }

  @Input()
  set bcacShowTableExcelIcon1(value) {
    this.tableIconRow.excelIcon1.show = true;
  }

  @Output()
  bcacBatchReviewEmit = new EventEmitter<any>();
  clickBatchReview() {
    let checkedIdList = [];
    for (let key in this.mapOfCheckedId) {
      if (this.mapOfCheckedId[key]) {

        checkedIdList.push(key);
      }
    }
    let checkedObjList = this.tableData.filter(element => checkedIdList.indexOf(element[this.tableContent.uniqueIndex] + "") > -1);
    // in语法有问题，舍弃in
    // let checkedObjList = this.tableData.filter(element=> (element[this.tableContent.uniqueIndex] + "") in checkedIdList);
    if (checkedObjList.length > 0) {
      this.bcacBatchReviewEmit.emit(checkedObjList);
    } else {
      this.nzMessageService.info("无选中记录");
    }
  }

  // @Input()
  // set bcacShowTableRefreshIcon(value) {
  //   this.tableIconRow.refreshIcon.show = true;
  // }

  @Input()
  set bcacCloseTableIcon(value) {
    this.tableIconRow.show = false;
  }
  @Input()
  set bcacCloseTableAddIcon(value) {
    this.tableIconRow.addIcon.show = false;
  }
  @Input()
  set bcacCloseTableConfigIcon(value) {
    this.tableIconRow.configIcon.show = false;
  }
  @Input()
  set bcacCloseTableDeleteIcon(value) {
    this.tableIconRow.deleteIcon.show = false;
  }

  @Input()
  set bcacCloseTableExcelIcon(value) {
    this.tableIconRow.excelIcon.show = false;
  }

  @Input()
  set bcacCloseBatchDownIcon(value) {
    this.tableIconRow.batchDownload.show = false;
  }

  @Input()
  set bcacCloseTableSearch(value) {
    this.tableIconRow.searchInput.show = false;
  }

  tableContent = {
    show: true,
    uniqueIndex: "rid",
    // tableData: [],
    pagination: {
      show: true,
      pageSize: 10,
      pageSizeOptions: [10, 20, 50, 100],
    },
    checkBox: {
      show: true,
      width: "3.8rem",
      checkField: "rid",
    },
    columnOptions: [],
    rowOperation: {
      show: true,
      label: "操作",
      width: "8rem",
      detailIcon: {
        show: true,
        label: "详情",
      },
      editorIcon: {
        show: false,
        label: "编辑",
      },
      deleteIcon: {
        show: false,
        label: "删除",
      },
      reviewIcon: {
        show: false,
        label: "审核"
      },
      reviewRecordIcon: {
        show: false,
        label: "审核记录"
      },
      previewIcon: {
        show: false,
        label: "预览"
      },
      downloadIcon: {
        show: false,
        label: "下载"
      },
      fillInIcon: {
        show: false,
        label: "填报"
      },
      submitIcon: {
        show: false,
        label: "提交"
      },
      turnDownIcon: {
        show: false,
        label: "驳回"
      },
      configIcon: {
        show: false,
        label: "设置"
      },
      distributeOrderIcon: {
        show: false,
        label: "派单"
      },
      clearIcon: {
        show: false,
        label: "清除"
      },
      receiveWorkOrderIcon: {
        show: false,
        label: "接单"
      },
      handleWorkOrderIcon: {
        show: false,
        label: "处理工单"
      },
      transferWorkOrderIcon: {
        show: false,
        label: "转派"
      },
      menuAuthorityIcon: {
        show: false,
        label: "菜单权限"
      }
    },
  };

  @Input()
  set bcacShowHandleWorkOrderRowIcon(value: boolean) {
    this.tableContent.rowOperation.handleWorkOrderIcon.show = true;
  }

  @Output()
  bcacRowHandleWorkOrderEmit = new EventEmitter<any>();
  clickRowHandleWorkOrder(data: any) {
    this.bcacRowHandleWorkOrderEmit.emit(data);
  }

  @Input()
  set bcacShowTransferWorkOrderRowIcon(value: boolean) {
    this.tableContent.rowOperation.transferWorkOrderIcon.show = true;
  }

  @Output()
  bcacRowTransferWorkOrderEmit = new EventEmitter<any>();
  clickRowTransferWorkOrder(data: any) {
    this.bcacRowTransferWorkOrderEmit.emit(data);
  }


  @Input()
  set bcacShowReceiveWorkOrderRowIcon(value: boolean) {
    this.tableContent.rowOperation.receiveWorkOrderIcon.show = true;
  }

  @Output()
  bcacRowReceiveWorkOrderEmit = new EventEmitter<any>();
  clickRowReceiveWorkOrder(data: any) {
    this.bcacRowReceiveWorkOrderEmit.emit(data);
  }

  @Input()
  set bcacShowClearRowIcon(value: boolean) {
    this.tableContent.rowOperation.clearIcon.show = true;
  }

  @Output()
  bcacRowClearEmit = new EventEmitter<any>();
  clickRowClear(data: any) {
    this.bcacRowClearEmit.emit(data);
  }

  @Input()
  set bcacShowDistributeOrderRowIcon(value: boolean) {
    this.tableContent.rowOperation.distributeOrderIcon.show = true;
  }

  @Output()
  bcacRowDistributeOrderEmit = new EventEmitter<any>();
  clickRowDistributeOrder(data) {
    this.bcacRowDistributeOrderEmit.emit(data);
  }

  @Input()
  set bcacShowConfigRowIcon(value: boolean) {
    this.tableContent.rowOperation.configIcon.show = true;
  }

  @Output()
  bcacRowConfigEmit = new EventEmitter<any>();
  clickRowConfig(data: any) {
    this.bcacRowConfigEmit.emit(data);
  }

  @Input()
  set bcacShowSubmitRowIcon(value: boolean) {
    this.tableContent.rowOperation.submitIcon.show = true;
  }

  @Output()
  bcacRowSubmitEmit = new EventEmitter<any>();
  clickRowSubmit(data: any) {
    this.bcacRowSubmitEmit.emit(data);
  }

  @Input()
  set bcacShowdownloadIcon(value: boolean) {
    this.tableContent.rowOperation.downloadIcon.show = true;
  }

  @Output()
  bcacDownloadEmit = new EventEmitter<any>();
  clickDownload(data: any) {
    this.bcacDownloadEmit.emit(data);
  }

  @Output()
  bcacFillInEmit = new EventEmitter<any>();
  clickFillIn(data: any) {
    this.bcacFillInEmit.emit(data);
  }

  @Input()
  set bcacShowPreviewIcon(value: boolean) {
    this.tableContent.rowOperation.previewIcon.show = true;
  }

  @Output()
  bcacPreviewEmit = new EventEmitter<any>();
  clickPreview(data: any) {
    this.bcacPreviewEmit.emit(data);
  }
  @Output()
  bcacTurnDownEmit = new EventEmitter<any>();
  clickTurnDown(data: any) {
    this.bcacTurnDownEmit.emit(data);
  }

  @Input()
  set bcacShowReviewRecordIcon(value: boolean) {
    this.tableContent.rowOperation.reviewRecordIcon.show = true;
  }

  @Output()
  bcacReviewRecordEmit = new EventEmitter<any>();
  clickReviewRecord(data: any) {
    this.bcacReviewRecordEmit.emit(data);
  }

  @Input()
  set bcacShowMenuAuthorityIcon(value: boolean) {
    this.tableContent.rowOperation.menuAuthorityIcon.show = true;
  }

  @Output()
  bcacMenuAuthorityEmit = new EventEmitter();
  clickMenuAuthorityEmit(data: any) {
    this.bcacMenuAuthorityEmit.emit(data);
  }


  @Input()
  set bcacShowReviewIcon(value) {
    this.tableContent.rowOperation.reviewIcon.show = true;
  }

  @Input()
  set bcacShowTurnDownRowIcon(value) {
    this.tableContent.rowOperation.turnDownIcon.show = true;
  }

  @Input()
  set bcacColumnOptions(value) {
    this.tableContent.columnOptions = value;
  }

  @Input()
  set bcacCloseRowOperation(value) {
    this.tableContent.rowOperation.show = false;
  }

  @Input()
  set bcacRowOperationWidth(value) {
    this.tableContent.rowOperation.width = value;
  }

  @Input()
  set bcacCloseDetailRowIcon(value) {
    this.tableContent.rowOperation.detailIcon.show = false;
  }

  @Input()
  set bcacShowEditorRowIcon(value) {
    this.tableContent.rowOperation.editorIcon.show = true;
  }

  @Input()
  set bcacShowDeleteRowIcon(value) {
    this.tableContent.rowOperation.deleteIcon.show = true;
  }

  @Input()
  set bcacShowFillInRowIcon(value) {
    this.tableContent.rowOperation.fillInIcon.show = true;
  }

  @Input()
  set bcacUniqueIndex(value) {
    this.tableContent.uniqueIndex = value;
  }

  @Input()
  set bcacClosePagination(value) {
    this.tableContent.pagination.show = false;
  }

  @Input()
  set bcacPageSize(value) {
    this.tableContent.pagination.pageSize = value;
  }

  @Input()
  set bcacPageSizeOptions(value) {
    this.tableContent.pagination.pageSizeOptions = value;
  }

  @Input()
  set bcacCloseCheckBox(value) {
    this.tableContent.checkBox.show = false;
  }

  @Input()
  set bcacCheckBoxWidth(value) {
    this.tableContent.checkBox.width = value;
  }

  @Input()
  set bcacCheckField(value) {
    this.tableContent.checkBox.checkField = value;
  }

  // 分页函数
  isIndeterminate = false;
  isAllDisplayDataChecked: boolean = false;
  listOfDisplayData: any[] = [];
  mapOfCheckedId: { [key: string]: boolean } = {};
  currentPageDataChange($event: Array<{ rid: string }>): void {
    this.listOfDisplayData = $event;
    this.refreshStatus();
  }

  refreshStatus(): void {
    this.isAllDisplayDataChecked = this.listOfDisplayData.every(
      (item) => this.mapOfCheckedId[item[this.tableContent.uniqueIndex]]
    );
    this.isIndeterminate =
      this.listOfDisplayData.some(
        (item) => this.mapOfCheckedId[item[this.tableContent.uniqueIndex]]
      ) && !this.isAllDisplayDataChecked;
    this.checkBoxEmit.emit(this.mapOfCheckedId);
  }

  checkAll(value: boolean): void {
    this.listOfDisplayData.forEach(
      (item) =>
        (this.mapOfCheckedId[item[this.tableContent.uniqueIndex]] = value)
    );
    this.refreshStatus();
  }

  //列操作排序容器
  mapOfSort: { [key: string]: string | null } = {};
  initMapOfSort() {
    this.tableContent.columnOptions.forEach((element) => {
      let column = element.value;
      this.mapOfSort[column] = null;
    });
  }
  // sort事件
  sortName: string | null = null;
  sortValue: string | null = null;
  sort(sortName: string, value: string): void {
    this.sortName = sortName; //排序字段
    this.sortValue = value; //排序方式
    // 互斥排序模式
    for (const key in this.mapOfSort) {
      this.mapOfSort[key] = key === sortName ? value : null;
    }
    this.search();
  }


  initFilterListMapBak() {
    this.tableContent.columnOptions.forEach((element) => {
      let list = Array.from(
        new Set(this.tableData.map((item) => item[element.value]))
      ).map((e) => {
        if (element.tdType == "nzBadge" || element.tdType == "bgColor" || element.tdType == "bgColorCustom") {
          return { text: element.tooltipMap[e], value: e }
        } else {
          return { text: e, value: e };
        }
      });
      let column = element.value;
      this.filterListOfMap[column] = list;
      this.filterList.push(column);
      this.listOfFilterValueOfMap[column] = [];
    });
  }

  filterListOfMap = {};
  filterList = [];
  listOfFilterValueOfMap = {};
  initFilter
  initFilterListMap() {
    this.initFilter = []
    this.tableContent.columnOptions.forEach((element) => {
      let list = Array.from(
        new Set(this.tableData.map((item) => item[element.value]))
      ).map((e) => {
        let df = false;
        if (Boolean(element.dafaultFilter) && element.showFilter) {
          df = element.dafaultFilter.includes(e)
          this.initFilter.push({
            filed: element.value,
            event: element.dafaultFilter
          })
        }
        if (element.tdType == "nzBadge" || element.tdType == "bgColor" || element.tdType == "bgColorCustom") {         
          return { text: element.tooltipMap[e], value: e, byDefault: df }
        } else {
          return { text: e, value: e, byDefault: df };
        }
      });
      let column = element.value;
      this.filterListOfMap[column] = list;
      this.filterList.push(column);
      this.listOfFilterValueOfMap[column] = [];
    });
    this.initFilter = this.remove_duplicate(this.initFilter);

  }

  //去重
  remove_duplicate(oldlist) {
    let newlist = {};
    return oldlist.reduce((p, c) => {
      newlist[c.filed] ? '' : newlist[c.filed] = true && p.push(c);
      return p
    }, []);
  }

  filter(event, field) {
    this.listOfFilterValueOfMap[field] = event;
    this.search();
  }

  searchDropMenuVisible: boolean = false;
  columnSearchValueMap = {};
  columnSearchList = [];
  initColumnSearchValueMap() {
    this.tableContent.columnOptions.forEach((element) => {
      let column = element.value;
      this.columnSearchValueMap[column] = "";
      this.columnSearchList.push(column);
    });
  }

  reset(value): void {
    this.columnSearchValueMap[value] = "";
    this.search();
  }

  // checkedcol = [];
  columnCheckChange(value: object[]): void {
    // this.checkedcol = this.tableContent.columnOptions
    //   .filter((e) => e.checked === true)
    //   .map((e) => e.value);
  }

  deleteRowCancel(): void {
    // this.nzMessageService.info("点击取消");
  }


  isMulltipleData = false;
  tableSourceDatas: {
    label: string,
    value: any[]
  }[] = [];

  @Input()
  set bcacOpenMultipleData(value: boolean) {
    this.isMulltipleData = true;
  }
  selectValue;

  dataSelectWidth = "8rem";

  @Input()
  set bcacDataSelectWidth(value: string) {
    this.dataSelectWidth = value;
  }

  selectValueChange(data) {
    this.tableData = data;
    this.tableDataInit();
  }

  @Input()
  set tabledatas(value) {
    if (this.isMulltipleData) {
      this.tableSourceDatas = value;
      if (this.tableSourceDatas.length > 0) {
        this.selectValue = this.tableSourceDatas[0].value;
        this.tableData = this.selectValue;
        this.tableDataInit();
      }
    } else {
      // 装填数据时 清空上次选中内容
      this.mapOfCheckedId = {};
      this.isAllDisplayDataChecked = false;
      this.isIndeterminate = false;
      this.tableData = value;
      this.tableDataInit();
    }
  }

  initTableSearchValue() {
    this.tableSearchValue = "";
  }


  ngOnInit() {
    this.tableDataInit();
    for (const item of this.initFilter) {
      this.filter(item.event, item.filed)
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.tabledatas
      && changes.tabledatas.currentValue
      && changes.tabledatas.currentValue.length) {
      for (const item of this.initFilter) {
        this.filter(item.event, item.filed)
      }
    }

  }

  tableDataInit() {
    this.tableData_bak = this.tableData;
    // this.checkedcol = this.tableContent.columnOptions
    //   .filter((e) => e.checked === true)
    //   .map((e) => e.value);
    this.initTableSearchValue();
    this.initMapOfSort();
    this.initFilterListMap();
    this.initColumnSearchValueMap();
    this.initSearchDropMenuVisibleMap();
  }

  searchDropMenuVisibleMap: { [key: string]: boolean | null } = {};
  initSearchDropMenuVisibleMap() {
    this.tableContent.columnOptions.forEach((element) => {
      let column = element.value;
      this.searchDropMenuVisibleMap[column] = false;
    });
  }

  tableData_bak = [];

  search(): void {
    //列选择过滤搜索函数
    const filterFunc = (item) => {
      let filterResult = true;
      for (let i = 0; i < this.filterList.length; i++) {
        let column = this.filterList[i];
        if (
          this.listOfFilterValueOfMap[column].length &&
          this.listOfFilterValueOfMap[column].every(
            (name) => String(item[column]).indexOf(name) === -1
          )
        ) {
          filterResult = false;
          break;
        }
      }
      return filterResult;
    };

    const filterFuncAll = (item) => {
      let filterAllResult = false;
      for (let i = 0; i < this.tableContent.columnOptions.length; i++) {
        let column = this.tableContent.columnOptions[i].value;
        if (
          item[column] &&
          new String(item[column]).indexOf(this.tableSearchValue) !== -1
        ) {
          filterAllResult = true;
          break;
        }
      }
      return filterAllResult;
    };
    // 列模糊搜索函数
    const singleColumnSearch = (item) => {
      let columnSearchResult = true;
      for (let i = 0; i < this.columnSearchList.length; i++) {
        let column = this.columnSearchList[i];
        if (
          this.columnSearchValueMap[column] &&
          new String(item[column]).indexOf(this.columnSearchValueMap[column]) === -1
        ) {
          columnSearchResult = false;
          break;
        }
      }
      return columnSearchResult;
    };
    const complexFilter = (item) => {
      return (
        filterFunc(item) && filterFuncAll(item) && singleColumnSearch(item)
      );
    };
    let filterData = this.tableData_bak;
    filterData = this.tableData_bak.filter((item) => complexFilter(item));
    // if ((this.listOfSearchMnName.length || this.listOfSearchAdmin.length) || this.searchValue || this.addrSearchValue) {

    // } else {
    //   filterData = this.tableData_bak.filter((item)=> item);
    // }
    if (this.sortValue != null) {
      this.tableData = filterData.sort((a, b) =>
        // this.sortValue === "ascend"
        //   ? a[this.sortName!] > b[this.sortName!]
        //     ? 1
        //     : -1
        //   : b[this.sortName!] > a[this.sortName!]
        //   ? 1
        //   : -1
        this.sortValue === "ascend"
          ? isNaN(a[this.sortName!] - b[this.sortName!]) ? a[this.sortName!] > b[this.sortName!] ? 1 : -1 : a[this.sortName!] - b[this.sortName!] > 0 ? 1 : -1
          : isNaN(b[this.sortName!] - a[this.sortName!]) ? b[this.sortName!] > a[this.sortName!] ? 1 : -1 : b[this.sortName!] - a[this.sortName!] > 0 ? 1 : -1
      );
    } else {
      this.tableData = filterData;
    }
    this.searchDropMenuVisible = false;
    // this.nzModalService.closeAll();
    // this.addrSearchDropMenuVisible=false;
  }

  allChecked = false;
  indeterminate = true;
  updateAllChecked(): void {
    this.indeterminate = false;
    if (this.allChecked) {
      this.tableContent.columnOptions = this.tableContent.columnOptions.map(
        (item) => {
          return {
            ...item,
            checked: true,
          };
        }
      );
    } else {
      this.tableContent.columnOptions = this.tableContent.columnOptions.map(
        (item) => {
          return {
            ...item,
            checked: false,
          };
        }
      );
    }
    // this.checkedcol = this.tableContent.columnOptions
    //   .filter((e) => e.checked === true)
    //   .map((e) => e.value);
  }

  updateSingleChecked(): void {
    if (this.tableContent.columnOptions.every((item) => !item.checked)) {
      this.allChecked = false;
      this.indeterminate = false;
    } else if (this.tableContent.columnOptions.every((item) => item.checked)) {
      this.allChecked = true;
      this.indeterminate = false;
    } else {
      this.indeterminate = true;
    }
  }
  @Output()
  exportExcel1Emit = new EventEmitter<any>();
  exportExcel1() {
    this.exportExcel1Emit.emit('exportExcel1')
    
  }

  exportExcel() {
    let exportData = [];
    let tempData = [];
    if (this.tableContent.checkBox.show) {
      let checkedIdList = [];
      for (let key in this.mapOfCheckedId) {
        if (this.mapOfCheckedId[key]) {
          checkedIdList.push(key);
        }
      }
      let checkedObjList = this.tableData.filter(element => checkedIdList.indexOf(element[this.tableContent.uniqueIndex] + "") > -1);
      tempData = checkedObjList;
    } else {
      tempData = this.tableData;
    }
    tempData.forEach((element) => {
      let dataObj = {};
      this.tableContent.columnOptions.forEach((column) => {
        if (column.checked) {
          dataObj[column.label] = element[column.value]
        }
      });
      exportData.push(dataObj);
    });
    if (exportData.length === 0) {
      let dataObj = {};
      this.tableContent.columnOptions.forEach((column) => {
        if (column.checked) {
          dataObj[column.label] = "";
        }
      });
      exportData.push(dataObj);
    }
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ["data"],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
    });
    if (this.tableTitle.label) {
      saveAs(blob, this.tableTitle.label);
    } else {
      saveAs(blob, "数据表");
    }
  }

  columnConfigPanelWidth = "14rem";
  @Input()
  set columnConfigWidth(value: string) {
    this.columnConfigPanelWidth = value;
  }

  switchLoadingMap = {};
  switchChange(value) {
    console.log("value", value);
  }

  clickSwitch(data: any, index: number, field: string, switchInfo: any) {
    this.switchLoadingMap[index + field] = true;
    this.tableService.accessInterface(switchInfo.interfaceUrl, switchInfo.method, switchInfo.token, data)
      .subscribe((res: any) => {
        this.switchLoadingMap[index + field] = false;
        data[field] = !data[field]
      }, error => {
        this.nzMessageService.error("操作失败");
        this.switchLoadingMap[index + field] = false;
      });
  }

  // testLabel="2010-12-12";
  testLabel2 = "-99";

  getGradientColor(value, item) {
    if (!_.isNil(value)) {
      let colorIndex = 0;
      if (+value - (+item.colorMap.valueRange[0]) >= 0 && (+value - (+item.colorMap.valueRange[0])) < 1) {
        colorIndex = Math.floor((+value - item.colorMap.valueRange[0]) * 100);
      } else {
        colorIndex = Number(Number(value).toFixed(0)) - Number(item.colorMap.valueRange[0]);
      }

      // let colorIndex = Number(Number(value).toFixed(0)) - Number(item.colorMap.valueRange[0]);
      if (_.isNil(this.colorRange[item.value])) {
        this.colorRange[item.value] = [];
        let step = 0;
        if (+item.colorMap.valueRange[1] - (+item.colorMap.valueRange[0]) >= 0 && (+item.colorMap.valueRange[1] - (+item.colorMap.valueRange[0])) < 1) {
          step = Math.floor((+item.colorMap.valueRange[1] - (+item.colorMap.valueRange[0])) * 100 / (item.colorMap.colorRange.length - 1));
        } else {
          step = Math.round((Number(item.colorMap.valueRange[1]) - Number(item.colorMap.valueRange[0])) / (item.colorMap.colorRange.length - 1));
        }

        // step = Math.round((Number(item.colorMap.valueRange[1]) - Number(item.colorMap.valueRange[0]))/(item.colorMap.colorRange.length - 1));
        for (let i = 0; i < item.colorMap.colorRange.length - 1; i++) {
          this.colorRange[item.value] = this.colorRange[item.value].concat(this.gradient(item.colorMap.colorRange[i], item.colorMap.colorRange[i + 1], step));
        }
      }
      if (colorIndex > this.colorRange[item.value].length - 1 || +value > +item.colorMap.valueRange[1]) {
        return this.colorRange[item.value][this.colorRange[item.value].length - 1];
      } else if (colorIndex < 0) {
        return this.colorRange[item.value][0];
      } else {
        return this.colorRange[item.value][colorIndex];
      }
    } else {
      return "";
    }
  }
  gradient(startColor, endColor, step) {
    let startRGB = this.colorRgb(startColor);//转换为rgb数组模式
    let startR = startRGB[0];
    let startG = startRGB[1];
    let startB = startRGB[2];

    let endRGB = this.colorRgb(endColor);
    let endR = endRGB[0];
    let endG = endRGB[1];
    let endB = endRGB[2];

    let sR = (endR - startR) / step;//总差值
    let sG = (endG - startG) / step;
    let sB = (endB - startB) / step;

    var colorArr = [];
    for (var i = 0; i < step; i++) {
      //计算每一步的hex值
      var hex = this.colorHex('rgb(' + parseInt((sR * i + startR)) + ',' + parseInt((sG * i + startG)) + ',' + parseInt((sB * i + startB)) + ')');
      colorArr.push(hex);
    }
    return colorArr;

  }
  colorRgb(sColor) {
    var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
    var sColor = sColor.toLowerCase();
    if (sColor && reg.test(sColor)) {
      if (sColor.length === 4) {
        var sColorNew = "#";
        for (var i = 1; i < 4; i += 1) {
          sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
        }
        sColor = sColorNew;
      }
      //处理六位的颜色值
      var sColorChange = [];
      for (var i = 1; i < 7; i += 2) {
        sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
      }
      return sColorChange;
    } else {
      return sColor;
    }
  };
  colorHex(rgb) {
    var _this = rgb;
    var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
    if (/^(rgb|RGB)/.test(_this)) {
      var aColor = _this.replace(/(?:(|)|rgb|RGB)*/g, "").split(",");
      var strHex = "#";
      for (var i = 0; i < aColor.length; i++) {
        var hex = Number(aColor[i]).toString(16);
        hex = hex < '10' ? 0 + '' + hex : hex;// 保证每个rgb的值为2位
        if (hex === "0") {
          hex += hex;
        }
        strHex += hex;
      }
      if (strHex.length !== 7) {
        strHex = _this;
      }
      return strHex;
    } else if (reg.test(_this)) {
      var aNum = _this.replace(/#/, "").split("");
      if (aNum.length === 6) {
        return _this;
      } else if (aNum.length === 3) {
        var numHex = "#";
        for (var i = 0; i < aNum.length; i += 1) {
          numHex += (aNum[i] + aNum[i]);
        }
        return numHex;
      }
    } else {
      return _this;
    }
  }

  getTrClickBackgroundColor(data: any) {
    if (this.trClickConf.open) {
      if (this.activeTrId === data[this.tableContent.uniqueIndex]) {
        return {
          'background-color': this.trClickConf.activeColor
        };
      } else {
        return {};
      }
    } else {
      return {};
    }
  }
  // 获取 强调显示的值
  getEmphasisColor(data, emphasisValue) {
    if (!_.isNil(emphasisValue)) {
      if ( typeof(emphasisValue) === 'string') {
        if(data === emphasisValue) {
          return this.redColor;
        } 

      } else if (emphasisValue instanceof Array) {
        if (emphasisValue.includes(data)) {
          return this.redColor;
        }
      }
    }
  }
}
